import { render, staticRenderFns } from "./ArcCounter.vue?vue&type=template&id=2444fc5c&"
import script from "./ArcCounter.vue?vue&type=script&lang=js&"
export * from "./ArcCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArcCounter.vue"
export default component.exports